import { render, staticRenderFns } from "./PageIdentityVerification.vue?vue&type=template&id=df9bd156&"
import script from "./PageIdentityVerification.vue?vue&type=script&lang=ts&"
export * from "./PageIdentityVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports